import _get from 'lodash/get'

export const get_performance = state => _get(state, 'performance.performance')
export const get_checkin = state => _get(state, 'performance.checkin')
export const get_checkin_dates = state => _get(state, 'performance.checkinDates')
export const get_checkin_addons_dates = state => _get(state, 'performance.checkInAddonsDates')
